/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_EMP_FORMPOST, GET_EMP_DETAILDATA } from "../../actions";
import empApi from "../../utils/employeeAxios";

import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import { downloadUrl } from "../Settings/Config";
import { hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "employee";
var moduleName = "Employee";
var moduleID = 34;
const bloodGroup = [
  { label: "A-", value: "A-" },
  { label: "A+", value: "A+" },
  { label: "A1-", value: "A1-" },
  { label: "A1+", value: "A1+" },
  { label: "A1B-", value: "A1B-" },
  { label: "A1B+", value: "A1B+" },
  { label: "A2-", value: "A2-" },
  { label: "A2+", value: "A2+" },
  { label: "A2B-", value: "A2B-" },
  { label: "A2B+", value: "A2B+" },
  { label: "AB-", value: "AB-" },
  { label: "AB+", value: "AB+" },
  { label: "B-", value: "B-" },
  { label: "B+", value: "B+" },
  { label: "B1-", value: "B1-" },
  { label: "B1+", value: "B1+" },
  { label: "NA", value: "NA" },
  { label: "O-", value: "O-" },
  { label: "O+", value: "O+" },
];
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.match.params?.editID ?? '';
    this.state = {
      editID:editID,
      postdata: {
        empUserName: "",
        empPassword: "",
        empTitle: "",
        empFirstName: "",
        empLastName: "",
        empShortName: "",
        empCode: "",
        empDesignation: "",
        empDepartment: "",
        empCity: "",
        empAddress: "",
        empBloodGroup:"",
        empDOB: "",
        empDOJ: "",
        empReportingBy: "",
        empApprovedBy: "",
        empContractType: "",
        empEmail: "",
        empGender: "",
        empConfirmationDate: "",
        empDateOfLeaving: "",
        empLastWorkingDate: "",
        empPayStructureAppliedFromDate: "",
        empStatus: "",
        empPhoto:""
      },
      detaildata: [],
      designationList:[],
      departmentList:[],
      employeeList:[],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push("/hrms/" + module);
        } else {
          this.props.history.push("/search");
        }
      }
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push("/hrms/" + module);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadEmployee();
    this.loadDesignation();
    this.loadDepartment();
    if (this.state.editID !== "") {
      var params = {
        params:'',
        url: `${module}/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/hrms/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].success ===true) {
          var result = nextProps.detaildata[0].result;

          var empStatus = result.empStatus === "A" ? "Active" : "In Active";
          var status =
            result.empStatus !== "" && result.empStatus !== null
              ? {
                  label: empStatus,
                  value: result.empStatus,
                }
              : "";
          const empContractType = result.empContractType;
          let empContractType_ = ""
          if(empContractType===1) {
            empContractType_ = { value: "1", label: "Consultant" };
          }else if(empContractType===2) {
            empContractType_ = { value: "2", label: "Contract" };
          } else if(empContractType===3) {
            empContractType_ = { value: "3", label: "Trainee" };
          } else if(empContractType===4) {
            empContractType_ = { value: "4", label: "Probation" };
          } else if(empContractType===5) {
            empContractType_ = { value: "5", label: "Permanent" };
          }

          const empPhoto = result?.empPhoto ?? '';
          var clientupdatedata = {
            empUserName: result.empUserName,
            empPassword: "",
            empTitle: (result.empTitle!=="" && result.empTitle!==null)?{value : result.empTitle, label: result.empTitle}:'',
            empFirstName: result.empFirstName,
            empLastName: result.empLastName,
            empShortName: result.empShortName,
            empCode: result.empCode,
            empDesignation:(result.empDesignation!=="" && result.empDesignation!==null)?{value:result.empDesignation, label:result.designationName}:'',
            empDepartment: (result.empDepartment!=="" && result.empDepartment!==null)? {value:result.empDepartment, label:result.departmentName}:'',
            empCity: result.empCity,
            empAddress: result.empAddress,
            empBloodGroup: (result.empBloodGroup!=="" && result.empBloodGroup!==null)?{value : result.empBloodGroup, label: result.empBloodGroup}:'',
            empDOB: result.empDOB && result.empDOB!==null? new Date(result.empDOB):'',
            empDOJ: result.empDOJ && result.empDOJ!==null? new Date(result.empDOJ):'',
            empReportingBy: (result.empReportingBy!=="" && result.empReportingBy!==null)? {value:result.empReportingBy, label:result.empReporting}:'',
            empApprovedBy: (result.empApprovedBy!=="" && result.empApprovedBy!==null)? {value:result.empApprovedBy, label:result.empApproved}:'',
            empContractType: empContractType_,
            empEmail: result.empEmail,
            empGender: (result.empGender!=="" && result.empGender!==null)?{label:result.empGender, value:result.empGender}:'',
            empConfirmationDate: result.empConfirmationDate && result.empConfirmationDate!==null? new Date(result.empConfirmationDate):'',
            empDateOfLeaving: result.empDateOfLeaving && result.empDateOfLeaving!==null? new Date(result.empDateOfLeaving):'', 
            empLastWorkingDate: result.empLastWorkingDate && result.empLastWorkingDate!==null? new Date(result.empLastWorkingDate):'',
            empPayStructureAppliedFromDate: result.empPayStructureAppliedFromDate && result.empPayStructureAppliedFromDate!==null? new Date(result.empPayStructureAppliedFromDate):'',
            empStatus: status,
            empPhoto:(empPhoto!==null && empPhoto!=="")?`${downloadUrl}employeedoc/photos/${empPhoto}`:''
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/hrms/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};
  loadEmployee() {
    empApi.get(`${module}/dropdown`).then((res) => {
      if (res.data.success === true) {
        this.setState({ employeeList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadDesignation() {
    empApi.get(`${module}/designation/dropdown`).then((res) => {
      if (res.data.success === true) {
        this.setState({ designationList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadDepartment() {
    empApi.get(`${module}/department/dropdown`).then((res) => {
      if (res.data.success === true) {
        this.setState({ departmentList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  
  

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      empUserName: postData.empUserName,
      empPassword: postData.empPassword,
      empTitle: postData.empTitle?.value ?? "Mr",
      empFirstName: postData.empFirstName,
      empLastName: postData.empLastName,
      empShortName: postData.empShortName,
      empCode: postData.empCode,
      empDesignation: postData.empDesignation?.value ?? '',
      empDepartment: postData.empDepartment?.value ?? '',
      empBloodGroup: postData.empBloodGroup?.value ?? '',
      empCity: postData.empCity,
      empAddress: postData.empAddress,
      empDOB: postData.empDOB,
      empDOJ: postData.empDOJ,
      empReportingBy: postData.empReportingBy?.value ?? '',
      empApprovedBy: postData.empApprovedBy?.value ?? '',
      empContractType: postData.empContractType?.value ?? '',
      empEmail: postData.empEmail,
      empGender: postData.empGender?.value ?? '',
      empConfirmationDate: postData.empConfirmationDate,
      empDateOfLeaving: postData.empDateOfLeaving,
      empLastWorkingDate: postData.empLastWorkingDate,
      empPayStructureAppliedFromDate: postData.empPayStructureAppliedFromDate,
      empStatus: postData.status?.value ?? 'A',
    };

    const formData = new FormData();

    // 🔁 Automatically append all fields from postdata
    Object.entries(postObject).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const fileInput = document.getElementById('employeePhotoFile');
    const file = fileInput.files[0]; // for single file

    if (file) {
      formData.append("empPhoto", file);
    }


    var post_url = `${module}/create`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(formData, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="employee" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={`/hrms/${module}`}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            designationList={this.state.designationList}
                            departmentList={this.state.departmentList}
                            employeeList={this.state.employeeList}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.empformpost,
    detaildata: state.empdetaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_EMP_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_EMP_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    empUserName,
    empPassword,
    empTitle,
    empFirstName,
    empLastName,
    empCode,
    empDesignation,
    empDepartment,
    empBloodGroup,
    empCity,
    empDOB, empDOJ, empReportingBy, empApprovedBy, empContractType, empEmail, empGender, empStatus,
    editID
  } = props.fields;

  let  validations = {
      empUserName: [[isEmpty, empUserName]],
      
      empTitle: [[isSingleSelect, empTitle]],
      empFirstName: [[isEmpty, empFirstName]],
      empLastName: [[isEmpty, empLastName]],
      empCode: [[isEmpty, empCode]],
      empDesignation: [[isSingleSelect, empDesignation]],   
      empDepartment: [[isSingleSelect, empDepartment]],
      empBloodGroup: [[isSingleSelect, empBloodGroup]],
      empCity: [[isEmpty, empCity]],      
      empDOB: [[isEmpty, empDOB]],
      empDOJ: [[isEmpty, empDOJ]],
      empReportingBy: [[isSingleSelect, empReportingBy]],
      empApprovedBy: [[isSingleSelect, empApprovedBy]], 
      empContractType: [[isSingleSelect, empContractType]],
      empEmail: [[isEmpty, empEmail]],
      empGender: [[isSingleSelect, empGender]],
      empStatus: [[isSingleSelect, empStatus]],
    }
  if(editID==="") {
    validations.empPassword = [[isEmpty, empPassword]];
  }

  return {
    fields: [
      "empUserName",
      "empPassword",
      "empTitle",
      "empFirstName",
      "empLastName",
      "empDesignation",
      "empDepartment",
      "empBloodGroup",
      "empCity",
      "empDOB",
      "empDOJ", "empReportingBy", "empApprovedBy", "empContractType", "empEmail", "empGender", "empStatus"
    ],
    validations:validations,
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push(`/hrms/${module}`);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChange(name, value) {
    this.props.onChange(name, value);
  }

  handleImageChange = (event) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      const imageUrl = URL.createObjectURL(file); // Create a URL for the selected file
      this.props.onChange('empPhoto', imageUrl);
    }
  };
  removePhoto() {
    this.props.onChange('empPhoto', "");
    $('#employeePhotoFile').val('');
  }
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgempUserName,
      errMsgempPassword,
      errMsgempTitle,
      errMsgempFirstName,
      errMsgempLastName, errMsgempCode, errMsgempDesignation, errMsgempDepartment, errMsgempBloodGroup, errMsgempCity, errMsgempDOB, errMsgempDOJ, errMsgempReportingBy, errMsgempApprovedBy, errMsgempContractType, errMsgempEmail, errMsgempGender, errMsgStatus = "";

    if ($validation.empUserName.error.reason !== undefined) {
      errMsgempUserName = $validation.empUserName.show && (
        <span className="error">{$validation.empUserName.error.reason}</span>
      );
    }
    if(fields.editID==="") {
      if ($validation.empPassword.error.reason !== undefined) {
        errMsgempPassword = $validation.empPassword.show && (
          <span className="error">{$validation.empPassword.error.reason}</span>
        );
      }
    }
    if ($validation.empTitle.error.reason !== undefined) {
      errMsgempTitle = $validation.empTitle.show && (
        <span className="error">{$validation.empTitle.error.reason}</span>
      );
    }
    if ($validation.empFirstName.error.reason !== undefined) {
      errMsgempFirstName = $validation.empFirstName.show && (
        <span className="error">{$validation.empFirstName.error.reason}</span>
      );
    }
    if ($validation.empLastName.error.reason !== undefined) {
      errMsgempLastName = $validation.empLastName.show && (
        <span className="error">{$validation.empLastName.error.reason}</span>
      );
    }
    if ($validation.empCode.error.reason !== undefined) {
      errMsgempCode = $validation.empCode.show && (
        <span className="error">{$validation.empCode.error.reason}</span>
      );
    }
    if ($validation.empDesignation.error.reason !== undefined) {
      errMsgempDesignation = $validation.empDesignation.show && (
        <span className="error">{$validation.empDesignation.error.reason}</span>
      );
    }
    if ($validation.empDepartment.error.reason !== undefined) {
      errMsgempDepartment = $validation.empDepartment.show && (
        <span className="error">{$validation.empDepartment.error.reason}</span>
      );
    }
    if ($validation.empBloodGroup.error.reason !== undefined) {
      errMsgempBloodGroup = $validation.empBloodGroup.show && (
        <span className="error">{$validation.empBloodGroup.error.reason}</span>
      );
    }    
    if ($validation.empCity.error.reason !== undefined) {
      errMsgempCity = $validation.empCity.show && (
        <span className="error">{$validation.empCity.error.reason}</span>
      );
    }
    if ($validation.empDOB.error.reason !== undefined) {
      errMsgempDOB = $validation.empDOB.show && (
        <span className="error">{$validation.empDOB.error.reason}</span>
      );
    }
    if ($validation.empDOJ.error.reason !== undefined) {
      errMsgempDOJ = $validation.empDOJ.show && (
        <span className="error">{$validation.empDOJ.error.reason}</span>
      );
    }
    if ($validation.empReportingBy.error.reason !== undefined) {
      errMsgempReportingBy = $validation.empReportingBy.show && (
        <span className="error">{$validation.empReportingBy.error.reason}</span>
      );
    }
    if ($validation.empApprovedBy.error.reason !== undefined) {
      errMsgempApprovedBy = $validation.empApprovedBy.show && (
        <span className="error">{$validation.empApprovedBy.error.reason}</span>
      );
    }
    if ($validation.empContractType.error.reason !== undefined) {
      errMsgempContractType = $validation.empContractType.show && (
        <span className="error">{$validation.empContractType.error.reason}</span>
      );
    }
    if ($validation.empEmail.error.reason !== undefined) {
      errMsgempEmail = $validation.empEmail.show && (
        <span className="error">{$validation.empEmail.error.reason}</span>
      );
    }
    if ($validation.empGender.error.reason !== undefined) {
      errMsgempGender = $validation.empGender.show && (
        <span className="error">{$validation.empGender.error.reason}</span>
      );
    }
    if ($validation.empStatus.error.reason !== undefined) {
      errMsgStatus = $validation.empStatus.show && (
        <span className="error">{$validation.empStatus.error.reason}</span>
      );
    }
    const dobmaxDate = new Date();
    dobmaxDate.setFullYear(dobmaxDate.getFullYear() - 18);
    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                User Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="User Name"
                name="empUserName"
                value={fields.empUserName}
                {...$field("empUserName", (e) =>
                  onChange("empUserName", e.target.value)
                )}
                readOnly={this.props.editID !== "" ? true : false}
              />
              {errMsgempUserName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Password<span className="lbl-error">*</span>
              </label>
              <div className="validate-input input-group" id="Password-toggle">
                <a
                  href={void 0}
                  className="input-group-text bg-white text-muted"
                >
                  <i
                    className="zmdi zmdi-eye text-muted"
                    aria-hidden="true"
                  ></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Password"
                  value={fields.empPassword}
                  {...$field("empPassword", (e) =>
                    onChange("empPassword", e.target.value)
                  )}
                />
                {errMsgempPassword}
              </div>
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Title<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empTitle}
                onChange={this.handleSelectChange.bind(this, "empTitle")}
                placeholder="Select Title"
                isClearable={true}
                options={[
                  { value: "Mr", label: "Mr" },
                  { value: "Mrs", label: "Mrs" },
                  { value: "Ms", label: "Ms" },
                  { value: "Miss", label: "Miss" },
                ]}
              />
              {errMsgempTitle}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                First Name<span className="lbl-error">*</span>
              </label>

              <input
                type="text"
                className="form-control upper-case"
                placeholder="First Name"
                name="empFirstName"
                value={fields.empFirstName}
                {...$field("empFirstName", (e) =>
                  onChange("empFirstName", e.target.value)
                )}
              />
              {errMsgempFirstName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Last Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Last Name"
                name="empLastName"
                value={fields.empLastName}
                {...$field("empLastName", (e) =>
                  onChange("empLastName", e.target.value)
                )}
              />
              {errMsgempLastName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Short Name
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Short Name"
                name="empShortName"
                value={fields.empShortName}
                {...$field("empShortName", (e) =>
                  onChange("empShortName", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Employee Code<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Employee Code"
                name="empCode"
                value={fields.empCode}
                {...$field("empCode", (e) =>
                  onChange("empCode", e.target.value)
                )}
              />
              {errMsgempCode}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
              Designation<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empDesignation}
                onChange={this.handleSelectChange.bind(this, "empDesignation")}
                placeholder="Select Designation"
                isClearable={true}
                options={this.props.designationList}
              />
              {errMsgempDesignation}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
              Department<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empDepartment}
                onChange={this.handleSelectChange.bind(this, "empDepartment")}
                placeholder="Select Department"
                isClearable={true}
                options={this.props.departmentList}
              />
              {errMsgempDepartment}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Blood Group<span className="lbl-error">*</span></label>
              <Select
                value={fields.empBloodGroup}
                onChange={this.handleSelectChange.bind(this, "empBloodGroup")}
                placeholder="Select Blood Group"
                isClearable={true}
                options={bloodGroup}
              />
              {errMsgempBloodGroup}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
               City<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="City"
                name="empCity"
                value={fields.empCity}
                {...$field("empCity", (e) =>
                  onChange("empCity", e.target.value)
                )}
              />
              {errMsgempCity}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
               Address<span className="lbl-error">*</span>
              </label>
              <textarea className="form-control"
                placeholder="City"
                name="empAddress"
                {...$field("empAddress", (e) =>
                  onChange("empAddress", e.target.value)
                )} value={fields.empAddress} />
            </div>
            
            <div className="form-group col-md-3">
              <label className="form-label">
                Date Of Birth<span className="lbl-error">*</span>
              </label>

              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empDOB}
                maxDate={dobmaxDate}
                placeholder="Date Of Birth"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empDOB"
                )}
              />
              {errMsgempDOB}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Date Of Join<span className="lbl-error">*</span>
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empDOJ}
                placeholder="Date Of Join"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empDOJ"
                )}
              />
              {errMsgempDOJ}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Reporting To<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empReportingBy}
                onChange={this.handleSelectChange.bind(this, "empReportingBy")}
                placeholder="Select Reporting By"
                isClearable={true}
                options={this.props.employeeList}
              />
              {errMsgempReportingBy}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
               Approved By<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empApprovedBy}
                onChange={this.handleSelectChange.bind(this, "empApprovedBy")}
                placeholder="Select Title"
                isClearable={true}
                options={this.props.employeeList}
              />
              {errMsgempApprovedBy}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
               Contract Type<span className="lbl-error">*</span>
              </label>              
              <Select
                value={fields.empContractType}
                onChange={this.handleSelectChange.bind(this, "empContractType")}
                placeholder="Select Title"
                isClearable={true}
                options={[
                  { value: "1", label: "Consultant" },
                  { value: "2", label: "Contract" },
                  { value: "3", label: "Trainee" },
                  { value: "4", label: "Probation" },
                  { value: "5", label: "Permanent" }
                ]}
              />
              {errMsgempContractType}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Email<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="empEmail"
                value={fields.empEmail}
                {...$field("empEmail", (e) =>
                  onChange("empEmail", e.target.value)
                )}
              />
              {errMsgempEmail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Gender<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empGender}
                onChange={this.handleSelectChange.bind(this, "empGender")}
                placeholder="Select Gender"
                isClearable={true}
                options={[
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" },
                  { value: "Transgender", label: "Transgender" }                  
                ]}
              />
              {errMsgempGender}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Confirmation Date
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empConfirmationDate}
                placeholder="Confirmation Date"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empConfirmationDate"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
              Date Of Leaving
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empDateOfLeaving}
                placeholder="Date Of Leaving"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empDateOfLeaving"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Last Working Date
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empLastWorkingDate}
                placeholder="Last Working Date"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empLastWorkingDate"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Pay Structure Applied From Date
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empPayStructureAppliedFromDate}
                placeholder="Pay Structure Applied From Date"
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(
                  this,
                  "empPayStructureAppliedFromDate"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empStatus}
                onChange={this.handleSelectChange.bind(this, "empStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: 'A', label: "Active" },
                  { value: 'I', label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
            <div className="form-group  col-md-3" style={{position:'relative'}}>
              {fields.empPhoto!=="" &&
                <>
                <button class="btn-close" style={{position:'absolute', left:'103px', top:'-11px'}} onClick={this.removePhoto.bind(this)} >
                  <span aria-hidden="true">×</span>
                </button>
                <img src={fields.empPhoto} alt="Photo" id="employeePhoto" className="employeePhoto" style={{width:'100px', height:'100px', marginBottom:'10px', borderRadius:'10px'}} />
                </>
              }
              <label className="form-label mt-0">Photo</label>
              <input className="form-control" type="file" id="employeePhotoFile" accept="image/*" onChange={this.handleImageChange.bind(this)} />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
